import mutations from './mutations';
import actions from './actions';
import getters from './getters';
export const getDefaultUserState = () => {
    return {
        access_token: '',
        expires_in: null,
        token_type: '',
        login_err_msg: ''
    };
};
export const state = getDefaultUserState();
export const auth = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
